import type { SessionResponse } from "@memorang/types";

const fetchSession = async (_params: {
	sessionId?: string;
	numericId?: number;
	userId: string;
}): Promise<{
	response: SessionResponse;
	lastUpdatedBlockIndex: number;
	lastUpdatedItemIndex: number;
	groupIndex: number;
	progressArray: { id: string; progress: number }[];
}> => {
	return {
		response: {
			id: "0",
			numericId: 0,
			sessionItems: [],
			sessionTime: 0,
			reportSessionType: "PRACTICETEST",
			hasMore: false,
			status: "ACTIVE",
			progressList: [],
		} satisfies SessionResponse,
		lastUpdatedBlockIndex: 0,
		lastUpdatedItemIndex: 1,
		groupIndex: 0,
		progressArray: [],
	};
};

export { fetchSession };
